function stickyScroll(){
  var scrollOffset = $(".shopify-section.sticky_navbar").offset(); 
    //caches a jQuery object containing the header element
    var header = $(".custom-navbar-sticky");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= scrollOffset.top) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
};
stickyScroll()


$(".sidebar__item").on("click", function(){
  if($(this).hasClass("selected-bassinet")){
     $(".sidebar-bassinets").removeClass("aside-hidden")
     $(".bassinet-slideout").addClass("show-slideout")  
     $(".container__aside").addClass("slide-in")
     $(".bassinet-slideout").removeClass("slide-in")
     $(".base-slideout").addClass("slide-in")
   }        
if($(this).hasClass("selected-base")){
     $(".sidebar-bases").removeClass("aside-hidden")
     $(".base-slideout").addClass("show-slideout")  
     $(".container__aside").addClass("slide-in")
     $(".bassinet-slideout").addClass("slide-in")
     $(".base-slideout").removeClass("slide-in")
   } 
  
})
$(".bassinet-swatch-close").on("click", function(){
    $(".aristot-builder-sidebar").addClass("aside-hidden")
    $(".swatch-slideout").removeClass("show-slideout")   
    $(".container__aside").removeClass("slide-in")
    $(".bassinet-slideout").removeClass("slide-in")
    $(".base-slideout").removeClass("slide-in")
})




 function initAristot() {
   
	 if ($('.aristot-navbar-sticky').length) {
		 $('body').addClass('aristot-styles');
	 }

	 var $navbarTrigger = $('.js-navbar-trigger');
	 var $navbarActions = $('.navbar__actions');
	 $navbarTrigger.on('click', function (event) {
		 event.preventDefault();
		 $navbarTrigger.toggleClass('clicked');
		 $navbarActions.slideToggle();
		 $('body').toggleClass('js-no-scroll-mobile');
	 });

	 function initAccordion() {
    
		 var isDesktop = $(window).width() > 1023;
		 var clickedOnceClass = 'clicked-once';
		 $('.has-dropdown > a, .has-megamenu > a').on('click', function (event) {
			 var $this = $(this);             
             //Following 3 lines causes the link to work on the second click, once the sub-menu item has expanded
			 if (isDesktop || $this.parent().hasClass(clickedOnceClass)) {
				 return true;               
			 }
			 event.preventDefault();
			 $this.siblings().slideDown().parent().addClass(clickedOnceClass).siblings().removeClass(clickedOnceClass).find('.dropdown, .megamenu').slideUp();
		 });
	 }

	 initAccordion();
	 var accordionActiveClass = 'is-active';
	 $('.aristot-accordion .accordion__head').on('click', function (event) {
     
		 $(this).siblings().slideToggle().parent().toggleClass(accordionActiveClass).siblings().removeClass(accordionActiveClass).find('.accordion__body').slideUp();
	 });
	 var $sliderTop = $('.js-aristot-slider.slider-builder-top');
	 var $sliderBot = $('.js-aristot-slider.slider-builder-bottom');
	 var sliderSettings = {
		 centerMode: true,
		 centerPadding: '20%',
		 responsive: [{
			 breakpoint: 767,
			 settings: {
				 centerPadding: 0,
				 arrows: false
			 }
		 }]
	 };
	 $sliderTop.find('.slider__slides').slick(sliderSettings);
	 $sliderBot.find('.slider__slides').slick(sliderSettings);

	 $('.sidebar-bassinets .sidebar__body a').click(function() {
       
		 var bassinetIndex = this.dataset.bassinet;
		 var bassinetSwatch = $(this).find('figure').clone();
		 var bassinetTitle = $(this).find('p').clone();
		 var bassinetPrice = $(this).find('span').clone();
         var bassinetBundleIds = $(this).data('bundles');
   
		 $($sliderTop.find('.slider__slides')).slick('slickGoTo', bassinetIndex);      
         $('.selected-bassinet').attr('data-bundles', bassinetBundleIds)
         $('.selected-bassinet').data('bundles', bassinetBundleIds)
             
		 $('.selected-bassinet figure').replaceWith(bassinetSwatch);
		 $('.selected-bassinet p').replaceWith(bassinetTitle);
		 $('.selected-bassinet span').replaceWith(bassinetPrice);
		 $('.sidebar-bassinets').addClass('aside-hidden');
		 $('.bassinet-slideout').removeClass('show-slideout');
         $(".container__aside").removeClass("slide-in")
         $(".bassinet-slideout").removeClass("slide-in")
         $(".base-slideout").removeClass("slide-in")
       
		 $('.sidebar-selected').removeClass('aside-hidden');
		 getActiveSlideTop();
	 });

	 $('.sidebar-bases .sidebar__body a').click(function() {
       
		 var baseIndex = this.dataset.base;
		 var baseSwatch = $(this).find('figure').clone();
		 var baseTitle = $(this).find('p').clone();
		 var basePrice = $(this).find('span').clone();
    
         var baseBundleIds = $(this).data('bundles');
        
		 $($sliderBot.find('.slider__slides')).slick('slickGoTo', baseIndex);

         $('.selected-base').attr('data-bundles', baseBundleIds)
         $('.selected-base').data('bundles', baseBundleIds)
       
		 $('.selected-base figure').replaceWith(baseSwatch);
		 $('.selected-base p').replaceWith(baseTitle);
		 $('.selected-base span').replaceWith(basePrice);
		 $('.sidebar-bases').addClass('aside-hidden');
		 $('.base-slideout').removeClass('show-slideout');
         $(".container__aside").removeClass("slide-in")
         $(".bassinet-slideout").removeClass("slide-in")
         $(".base-slideout").removeClass("slide-in")
		 $('.sidebar-selected').removeClass('aside-hidden');
		 getActiveSlideBottom();
       
	 });

	 $($sliderTop.find('.slider__slides')).on('afterChange', function(event, slick, currentSlide, nextSlide){
       console.log("top slide changed")

         $(".product-form__error-message-wrapper").attr("hidden", true);
         $(".product-form__error-message").text("")
       
		 var currentSlide = $($sliderTop.find('.slider__slides')).slick('slickCurrentSlide');
		 var newBassinet = $(".sidebar-bassinets").find("[data-bassinet='" + currentSlide + "']");
		 var bassinetSwatch = newBassinet.find('figure').clone();
		 var bassinetTitle = newBassinet.find('p').clone();
		 var bassinetPrice = newBassinet.find('span').clone();      
         var bassinetBundleIds = $(".slider__slide.bassinet-"+currentSlide).data("bundles")
         $('.selected-bassinet').attr('data-bundles', bassinetBundleIds)
         $('.selected-bassinet').data('bundles', bassinetBundleIds)            
		 $('.selected-bassinet figure').replaceWith(bassinetSwatch);
		 $('.selected-bassinet p').replaceWith(bassinetTitle);
		 $('.selected-bassinet span').replaceWith(bassinetPrice);         
		 populatePrice();
		 getActiveSlideTop();
	 });

	 $($sliderBot.find('.slider__slides')).on('afterChange', function(event, slick, currentSlide, nextSlide){
       console.log("bottom slide changed")
         $(".product-form__error-message-wrapper").attr("hidden", true);
         $(".product-form__error-message").text("")
       
         var currentSlide = $($sliderBot.find('.slider__slides')).slick('slickCurrentSlide');
		 var newBase = $(".sidebar-bases").find("[data-base='" + currentSlide + "']");
		 var baseSwatch = newBase.find('figure').clone();
		 var baseTitle = newBase.find('p').clone();
		 var basePrice = newBase.find('span').clone();     
         var baseBundleIds = $(".slider__slide.base-"+currentSlide).data("bundles")
         $('.selected-base').attr('data-bundles', baseBundleIds)
         $('.selected-base').data('bundles', baseBundleIds)       
		 $('.selected-base figure').replaceWith(baseSwatch);
		 $('.selected-base p').replaceWith(baseTitle);
		 $('.selected-base span').replaceWith(basePrice);        
		 populatePrice();
		 getActiveSlideBottom();
	 });

 
  function initStickySidebar() {
     var $sidebar = $('.js-aristot-builder-sidebar');
  
     if ($sidebar.length == 0) {
         return;
     }
  
     var sidebarHeight = $sidebar.height();
     var $sidebarContainer = $sidebar.parent();
     var $win = $(window);
     var navbar = document.querySelector('.navbar-sticky');
     var navbarHeight = navbar.offsetHeight;
     $win.on('scroll', function (event) {
         var scroll = $win.scrollTop();
         var isAtBottom = scroll + sidebarHeight - navbarHeight >= $sidebarContainer.height();
        // $sidebar.toggleClass('sticky-bottom', isAtBottom);
     });
   }

  initStickySidebar();
   
	 $('.aristot-section-gallery').slick({
		 arrows: false,
		 dots: false,
		 mobileFirst: true,
		 responsive: [{
			 breakpoint: 768,
			 settings: 'unslick'
		 }]
	 });

	 function initAlternateResolutionImages() {
		 var isMobile = $(window).width() < 768;
		 var $imageContainers = $('.js-alt-image');

		 if ($imageContainers.length) {
			 $imageContainers.each(function (index, item) {
				 if (isMobile) {
					 var mobileImage = item.querySelector('.image-mobile');

					 if (mobileImage != null) {
						 mobileImage.style = "background-image: url('".concat(mobileImage.getAttribute('data-bg'), "')");
					 }
				 } else {
					 var desktopImage = item.querySelector('.image-desktop');

					 if (desktopImage != null) {
						 desktopImage.style = "background-image: url('".concat(desktopImage.getAttribute('data-bg'), "')");
					 }
				 }
			 });
		 }
	 }

	 initAlternateResolutionImages();
	 $('.navbar-sticky a[href^="#"]').on('click', function (event) {
		 event.preventDefault();
		 var $target = $(this.hash);
		 var $navTrigger = $('.js-navbar-trigger');

		 if ($target.length == 0) {
			 var fallback = this.dataset.fallback;

			 if (fallback != null) {
				 location.href = fallback + '/' + this.hash;
			 }
		 }

		 $('html, body').animate({
			 scrollTop: $target.offset().top
		 }, 500, 'linear');

		 if ($navTrigger.hasClass('clicked')) {
			 $navTrigger.first().click();
		 }
	 });

	 if (location.hash && $(location.hash).length) {
		 $('html, body').animate({
			 scrollTop: $(location.hash).offset().top
		 }, 500, 'linear');
	 }
 }
 

initAristot() 

